import script from "./GalleryPhotoEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryPhotoEdit.vue?vue&type=script&setup=true&lang=js"

import "./GalleryPhotoEdit.vue?vue&type=style&index=0&id=5a267872&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a267872"]])

export default __exports__